import React from "react";
import ReportTemplate2 from "../reportTemplate2";

function MaterialDamageSummary() {
  const columns: any = [
    {
      title: "Site Name",
      key: "siteName",
      dataIndex: "siteName",
      width: 150,
    },
    {
      title: "Location",
      key: "location",
      width: 150,
      render: (text: any, record: any) => {
        // For Villa level, only show subUnitName as villa number
        if ((window as any).workBoqData?.workLevel === "Villa") {
          return record.subUnitName || "-";
        }

        // For other levels, build location path
        const location = [];
        if (record.unitName) location.push(record.unitName);
        if (record.floor) location.push(record.floor);
        if (record.subUnitName) location.push(record.subUnitName);
        return (
          <>
            <div className="fw-bold">{location.join(" / ") || "-"}</div>
            <div className="small">
              {(record.locationName && `${record.locationName}`) || ""}
            </div>
          </>
        );
      },
    },
    {
      title: "Category",
      key: "categoryName",
      dataIndex: "categoryName",
      width: 150,
    },
    {
      title: "Material",
      key: "materialName",
      dataIndex: "materialName",
      width: 150,
    },
    {
      title: "UOM",
      key: "uomName",
      dataIndex: "uomName",
      width: 150,
    },
    {
      title: "Issue QTY",
      key: "issueQyt",
      dataIndex: "issueQyt",
      width: 100,
      render: (text: string) => {
        const value = Number(text); // Convert text to a number
        if (isNaN(value)) {
          return <span style={{ textAlign: "right" }}>N/A</span>; // Handle invalid number
        }
        return <span style={{ textAlign: "right" }}>{value.toFixed(2)}</span>;
      },
    },
    {
      title: "Damaged QTY",
      key: "damagedQty",
      dataIndex: "damagedQty",
      width: 100,
      render: (text: string) => {
        const value = Number(text); // Convert text to a number
        if (isNaN(value)) {
          return <span style={{ textAlign: "right" }}>N/A</span>; // Handle invalid number
        }
        return <span style={{ textAlign: "right" }}>{value.toFixed(2)}</span>;
      },
    },
    {
      title: "% to Issued QTY",
      key: "damagedQtyPercentage",
      dataIndex: "damagedQtyPercentage",
      width: 100,
      render: (text: string) => {
        const value = Number(text); // Convert text to a number
        if (isNaN(value)) {
          return <span style={{ textAlign: "right" }}>N/A</span>; // Handle invalid number
        }
        return <span style={{ textAlign: "right" }}>{value.toFixed(2)} %</span>;
      },
    },
  ];
  return (
    <ReportTemplate2
      pageTitle="Material Damage Summary"
      pageDescription="	Overview of damaged materials recorded across all sites"
      moduleKey={window.location.pathname}
      columns={columns}
      filtersOption={{
        site: true,
        contractor: true,
        category: true,
        tower: true,
        floor: true,
        flat: true,
        location: true,
      }}
      previousPath="/view-material-management-reports"
    />
  );
}

export default MaterialDamageSummary;
